import { createSlice } from '@reduxjs/toolkit';
import { getImpressions } from 'pages/Promo/components/PromoCardDetails/components/Campaigns/getImpression';

const initialState = {
  modal: {
    state: false,
    data: {
      url: null,
      title: null,
      content: null,
      validation: null,
      dispatchAction: null,
      action: null
    }
  },
  previewModal: {
    state: false,
    data: {
      title: null,
      content: null
    }
  },
  formLoading: false,
  sidebar: false,
  sidebarCollapsed: false,
  loading: false,
  errors: null,
  impression: 0,
  overview_chart: {
    mode: null,
    chart_options: null
  },
  response: [],
  navPageContext: null
};

const miscSlice = createSlice({
  name: 'misc',
  initialState,
  reducers: {
    setFormLoading: (state, action) => {
      state.formLoading = action.payload === 'close' ? false : true;
    },
    setLoading: (state, action) => {
      state.loading = action.payload !== 'close';
    },
    showModal: (state, action) => {
      if (action.payload === 'close') {
        state.modal = initialState.modal;
      } else {
        state.modal = {
          state: true,
          data: action.payload
        };
      }
      state.formLoading = false;
    },
    getResponse: (state, action) => {
      state.response = action.payload;
    },
    previewModal: (state, action) => {
      if (action.payload === 'close') {
        state.previewModal = initialState.previewModal;
      } else {
        state.previewModal = {
          state: true,
          data: action.payload
        };
      }
    },
    showSidebar: (state, action) => {
      state.sidebar = action.payload === 'close' ? false : true;
    },
    toggleSidebarCollapsed: (state) => {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    setGraphData: (state, action) => {
      if (action.payload !== 'close') {
        state.overview_chart = action.payload;
      }
    },
    setErrors: (state, action) => {
      state.errors = action.payload;
    },
    setImpressions: (state, action) => {
      state.impression = getImpressions(action.payload);
    },
    setNavPageContext: (state, action) => {
      state.navPageContext = action.payload;
    },
    clearNavPageContext: (state) => {
      state.navPageContext = null;
    }
  }
});

export const {
  setFormLoading,
  setLoading,
  showModal,
  getResponse,
  previewModal,
  showSidebar,
  toggleSidebarCollapsed,
  setGraphData,
  setErrors,
  setImpressions,
  setNavPageContext,
  clearNavPageContext
} = miscSlice.actions;

export default miscSlice.reducer;